import { Icon } from '@components'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { useTheme } from '@react-navigation/native'
import { MyMemories, TaggedMemories } from '@screens'
import React from 'react'
import { Dimensions, View } from 'react-native'
import { TabBar } from './MemoryTabBar'

export type MemoryTabParamList = {
  MyMemories: undefined
  TaggedMemories: undefined
}

const { width, height } = Dimensions.get('window')

const Tab = createBottomTabNavigator<MemoryTabParamList>()

export const MemoryTabNavigator = () => {
  const { colors } = useTheme()

  return (
    <View
      style={{
        width,
        height,
      }}
    >
      <Tab.Navigator
        tabBar={(props) => <TabBar {...props} />}
        initialRouteName="MyMemories"
        screenOptions={{
          headerShown: false,
          tabBarStyle: {
            backgroundColor: colors.background,
          },
        }}
      >
        <Tab.Screen
          name="MyMemories"
          component={MyMemories}
          options={{
            title: 'My memories',
            tabBarIcon: ({ color, size }) => <Icon name="pictures" size={size} color={color} />,
          }}
        />

        <Tab.Screen
          name="TaggedMemories"
          component={TaggedMemories}
          options={{
            title: 'Tagged memories',
            tabBarIcon: ({ color, size }) => (
              <Icon name="taggedPictures" size={size} color={color} />
            ),
          }}
        />
      </Tab.Navigator>
    </View>
  )
}
